import { jsPDF } from 'jspdf'
import 'jspdf-autotable'
import utils from '@/mixins/utils.js'
import store from '@/store/store'
import { vue } from '@/main.js'

export function formatarCadastrosComDoses(cadastros) {
  const data = cadastros.map((item, index) => {
    const vacinasPendentes = JSON.parse(item.vacinas_pendentes)
    const vacinasAplicadas = JSON.parse(item.vacinas_aplicadas)

    // COVID 19
    const coresCovid19 = encontrarDosesCovid19(
      vacinasPendentes,
      vacinasAplicadas
    )

    // Hexa
    const coresHexa = createArrayDoses(3, ['1ª DOSE', '2ª DOSE', '3ª DOSE'])

    const primeiraDoseHexa = encontrarDose(
      vacinasPendentes,
      vacinasAplicadas,
      '43',
      '1'
    )
    const segundaDoseHexa = encontrarDose(
      vacinasPendentes,
      vacinasAplicadas,
      '43',
      '2'
    )
    const terceiraDoseHexa = encontrarDose(
      vacinasPendentes,
      vacinasAplicadas,
      '43',
      '3'
    )

    if (primeiraDoseHexa.tipo == 'aplicada') {
      coresHexa[0].cor = 'green'
      coresHexa[0].dt_aplicacao_br = primeiraDoseHexa.dt_aplicacao_br
      coresHexa[0].dose_anterior = primeiraDoseHexa.dose_anterior
    } else {
      coresHexa[0].cor = primeiraDoseHexa.cor
      coresHexa[0].sg_d = primeiraDoseHexa.sg_d
      coresHexa[0].sg_im = primeiraDoseHexa.sg_im
    }

    if (segundaDoseHexa.tipo == 'aplicada') {
      coresHexa[1].cor = 'green'
      coresHexa[1].dt_aplicacao_br = segundaDoseHexa.dt_aplicacao_br
      coresHexa[1].dose_anterior = segundaDoseHexa.dose_anterior
    } else {
      coresHexa[1].cor = segundaDoseHexa.cor
      coresHexa[1].sg_d = segundaDoseHexa.sg_d
      coresHexa[1].sg_im = segundaDoseHexa.sg_im
    }

    if (terceiraDoseHexa.tipo == 'aplicada') {
      coresHexa[2].cor = 'green'
      coresHexa[2].dt_aplicacao_br = terceiraDoseHexa.dt_aplicacao_br
      coresHexa[2].dose_anterior = terceiraDoseHexa.dose_anterior
    } else {
      coresHexa[2].cor = terceiraDoseHexa.cor
      coresHexa[2].sg_d = terceiraDoseHexa.sg_d
      coresHexa[2].sg_im = terceiraDoseHexa.sg_im
    }

    // Penta valente
    const coresPentaValente = createArrayDoses(3, [
      '1ª DOSE',
      '2ª DOSE',
      '3ª DOSE',
    ])

    const primeiraDosePenta = encontrarDose(
      vacinasPendentes,
      vacinasAplicadas,
      '42',
      '1'
    )
    const segundaDosePenta = encontrarDose(
      vacinasPendentes,
      vacinasAplicadas,
      '42',
      '2'
    )
    const terceiraDosePenta = encontrarDose(
      vacinasPendentes,
      vacinasAplicadas,
      '42',
      '3'
    )

    if (primeiraDosePenta.tipo == 'aplicada') {
      coresPentaValente[0].cor = 'green'
      coresPentaValente[0].dt_aplicacao_br = primeiraDosePenta.dt_aplicacao_br
      coresPentaValente[0].dose_anterior = primeiraDosePenta.dose_anterior
    } else {
      coresPentaValente[0].cor = primeiraDosePenta.cor
      coresPentaValente[0].dt_aplicacao_br = '2 meses'
      coresPentaValente[0].sg_d = primeiraDosePenta.sg_d
      coresPentaValente[0].sg_im = primeiraDosePenta.sg_im
    }

    if (segundaDosePenta.tipo == 'aplicada') {
      coresPentaValente[1].cor = 'green'
      coresPentaValente[1].dt_aplicacao_br =
        segundaDosePenta != undefined ? segundaDosePenta.dt_aplicacao_br : ''
      coresPentaValente[1].dose_anterior = segundaDosePenta.dose_anterior
    } else {
      coresPentaValente[1].cor = segundaDosePenta.cor
      coresPentaValente[1].dt_aplicacao_br = '4 meses'
      coresPentaValente[1].sg_d = segundaDosePenta.sg_d
      coresPentaValente[1].sg_im = segundaDosePenta.sg_im
    }

    if (terceiraDosePenta.tipo == 'aplicada') {
      coresPentaValente[2].cor = 'green'
      coresPentaValente[2].dt_aplicacao_br = terceiraDosePenta.dt_aplicacao_br
      coresPentaValente[2].dose_anterior = terceiraDosePenta.dose_anterior
    } else {
      coresPentaValente[2].cor = terceiraDosePenta.cor
      coresPentaValente[2].dt_aplicacao_br = '6 meses'
      coresPentaValente[2].sg_d = terceiraDosePenta.sg_d
      coresPentaValente[2].sg_im = terceiraDosePenta.sg_im
    }

    // Vip
    const coresVip = createArrayDoses(3, ['1ª DOSE', '2ª DOSE', '3ª DOSE'])
    const primeiraDoseVip = encontrarDose(
      vacinasPendentes,
      vacinasAplicadas,
      '22',
      '1'
    )
    const segundaDoseVip = encontrarDose(
      vacinasPendentes,
      vacinasAplicadas,
      '22',
      '2'
    )
    const terceiraDoseVip = encontrarDose(
      vacinasPendentes,
      vacinasAplicadas,
      '22',
      '3'
    )

    if (primeiraDoseVip.tipo == 'aplicada') {
      coresVip[0].cor = 'green'
      coresVip[0].dt_aplicacao_br = primeiraDoseVip.dt_aplicacao_br
      coresVip[0].dose_anterior = primeiraDoseVip.dose_anterior
    } else {
      coresVip[0].cor = primeiraDoseVip.cor
      coresVip[0].dt_aplicacao_br = '2 meses'
      coresVip[0].sg_d = primeiraDoseVip.sg_d
      coresVip[0].sg_im = primeiraDoseVip.sg_im
    }

    if (segundaDoseVip.tipo == 'aplicada') {
      coresVip[1].cor = 'green'
      coresVip[1].dt_aplicacao_br = segundaDoseVip.dt_aplicacao_br
      coresVip[1].dose_anterior = segundaDoseVip.dose_anterior
    } else {
      coresVip[1].cor = segundaDoseVip.cor
      coresVip[1].dt_aplicacao_br = '4 meses'
      coresVip[1].sg_d = segundaDoseVip.sg_d
      coresVip[1].sg_im = segundaDoseVip.sg_im
    }

    if (terceiraDoseVip.tipo == 'aplicada') {
      coresVip[2].cor = 'green'
      coresVip[2].dt_aplicacao_br = terceiraDoseVip.dt_aplicacao_br
      coresVip[2].dose_anterior = terceiraDoseVip.dose_anterior
    } else {
      coresVip[2].cor = terceiraDoseVip.cor
      coresVip[2].dt_aplicacao_br = '6 meses'
      coresVip[2].sg_d = terceiraDoseVip.sg_d
      coresVip[2].sg_im = terceiraDoseVip.sg_im
    }

    // DTP
    const coresDtp = createArrayDoses(2, ['1º REFORÇO', '2º REFORÇO'])
    const primeiroReforcoDoseDtp = encontrarDose(
      vacinasPendentes,
      vacinasAplicadas,
      '46',
      '6'
    )

    const segundoReforcoDoseDtp = encontrarDose(
      vacinasPendentes,
      vacinasAplicadas,
      '46',
      '7'
    )

    if (primeiroReforcoDoseDtp.tipo == 'aplicada') {
      coresDtp[0].cor = 'green'
      coresDtp[0].dt_aplicacao_br = primeiroReforcoDoseDtp.dt_aplicacao_br
      coresDtp[0].dose_anterior = primeiroReforcoDoseDtp.dose_anterior
    } else {
      coresDtp[0].cor = primeiroReforcoDoseDtp.cor
      coresDtp[0].dt_aplicacao_br = '15 meses'
      coresDtp[0].sg_d = primeiroReforcoDoseDtp.sg_d
      coresDtp[0].sg_im = primeiroReforcoDoseDtp.sg_im
    }

    if (segundoReforcoDoseDtp.tipo == 'aplicada') {
      coresDtp[1].cor = 'green'
      coresDtp[1].dt_aplicacao_br = segundoReforcoDoseDtp.dt_aplicacao_br
      coresDtp[1].dose_anterior = segundoReforcoDoseDtp.dose_anterior
    } else {
      coresDtp[1].cor = segundoReforcoDoseDtp.cor
      coresDtp[1].dt_aplicacao_br = '4 anos'
      coresDtp[1].sg_d = segundoReforcoDoseDtp.sg_d
      coresDtp[1].sg_im = segundoReforcoDoseDtp.sg_im
    }

    // BCG
    const coresBcg = createArrayDoses(1, ['ÚNICA'])
    const primeiraDoseBcg = encontrarDose(
      vacinasPendentes,
      vacinasAplicadas,
      '15',
      '9'
    )

    if (primeiraDoseBcg.tipo == 'aplicada') {
      coresBcg[0].cor = 'green'
      coresBcg[0].dt_aplicacao_br = primeiraDoseBcg.dt_aplicacao_br
      coresBcg[0].dose_anterior = primeiraDoseBcg.dose_anterior
    } else {
      coresBcg[0].cor = primeiraDoseBcg.cor
      coresBcg[0].dt_aplicacao_br = 'Ao nascer'
      coresBcg[0].sg_d = primeiraDoseBcg.sg_d
      coresBcg[0].sg_im = primeiraDoseBcg.sg_im
    }

    // Hepatite B
    const coresHepatiteB = createArrayDoses(4, [
      '1ª DOSE',
      '2ª DOSE',
      '3ª DOSE',
      'DOSE',
    ])

    const primeiraDoseHepatiteB = encontrarDose(
      vacinasPendentes,
      vacinasAplicadas,
      '9',
      '1'
    )

    const segundaDoseHepatiteB = encontrarDose(
      vacinasPendentes,
      vacinasAplicadas,
      '9',
      '2'
    )

    const terceiraDoseHepatiteB = encontrarDose(
      vacinasPendentes,
      vacinasAplicadas,
      '9',
      '3'
    )

    const doseHepatiteB = encontrarDose(
      vacinasPendentes,
      vacinasAplicadas,
      '9',
      '8'
    )

    if (primeiraDoseHepatiteB.tipo == 'aplicada') {
      coresHepatiteB[0].cor = 'green'
      coresHepatiteB[0].dt_aplicacao_br = primeiraDoseHepatiteB.dt_aplicacao_br
      coresHepatiteB[0].dose_anterior = primeiraDoseHepatiteB.dose_anterior
    } else {
      coresHepatiteB[0].cor = primeiraDoseHepatiteB.cor
      coresHepatiteB[0].sg_d = primeiraDoseHepatiteB.sg_d
      coresHepatiteB[0].sg_im = primeiraDoseHepatiteB.sg_im
    }

    if (segundaDoseHepatiteB.tipo == 'aplicada') {
      coresHepatiteB[1].cor = 'green'
      coresHepatiteB[1].dt_aplicacao_br = segundaDoseHepatiteB.dt_aplicacao_br
      coresHepatiteB[1].dose_anterior = segundaDoseHepatiteB.dose_anterior
    } else {
      coresHepatiteB[1].cor = segundaDoseHepatiteB.cor
      coresHepatiteB[1].sg_d = segundaDoseHepatiteB.sg_d
      coresHepatiteB[1].sg_im = segundaDoseHepatiteB.sg_im
    }

    if (terceiraDoseHepatiteB.tipo == 'aplicada') {
      coresHepatiteB[2].cor = 'green'
      coresHepatiteB[2].dt_aplicacao_br = terceiraDoseHepatiteB.dt_aplicacao_br
      coresHepatiteB[2].dose_anterior = terceiraDoseHepatiteB.dose_anterior
    } else {
      coresHepatiteB[2].cor = terceiraDoseHepatiteB.cor
      coresHepatiteB[2].sg_d = terceiraDoseHepatiteB.sg_d
      coresHepatiteB[2].sg_im = terceiraDoseHepatiteB.sg_im
    }

    if (doseHepatiteB.tipo == 'aplicada') {
      coresHepatiteB[3].cor = 'green'
      coresHepatiteB[3].dt_aplicacao_br = doseHepatiteB.dt_aplicacao_br
      coresHepatiteB[3].dose_anterior = doseHepatiteB.dose_anterior
    } else {
      coresHepatiteB[3].cor = doseHepatiteB.cor
      coresHepatiteB[3].dt_aplicacao_br = 'Ao nascer'
      coresHepatiteB[3].sg_d = doseHepatiteB.sg_d
      coresHepatiteB[3].sg_im = doseHepatiteB.sg_im
    }

    // VOP
    const coresVop = createArrayDoses(2, ['1º REFORÇO', '2º REFORÇO'])
    const primeiroReforcoDoseVop = encontrarDose(
      vacinasPendentes,
      vacinasAplicadas,
      '28',
      '6'
    )
    const segundoReforcoDoseVop = encontrarDose(
      vacinasPendentes,
      vacinasAplicadas,
      '28',
      '7'
    )

    if (primeiroReforcoDoseVop.tipo == 'aplicada') {
      coresVop[0].cor = 'green'
      coresVop[0].dt_aplicacao_br = primeiroReforcoDoseVop.dt_aplicacao_br
      coresVop[0].dose_anterior = primeiroReforcoDoseVop.dose_anterior
    } else {
      coresVop[0].cor = primeiroReforcoDoseVop.cor
      coresVop[0].dt_aplicacao_br = '15 meses'
      coresVop[0].sg_d = primeiroReforcoDoseVop.sg_d
      coresVop[0].sg_im = primeiroReforcoDoseVop.sg_im
    }

    if (segundoReforcoDoseVop.tipo == 'aplicada') {
      coresVop[1].cor = 'green'
      coresVop[1].dt_aplicacao_br = segundoReforcoDoseVop.dt_aplicacao_br
      coresVop[1].dose_anterior = segundoReforcoDoseVop.dose_anterior
    } else {
      coresVop[1].cor = segundoReforcoDoseVop.cor
      coresVop[1].dt_aplicacao_br = '4 anos'
      coresVop[1].sg_d = segundoReforcoDoseVop.sg_d
      coresVop[1].sg_im = segundoReforcoDoseVop.sg_im
    }

    // Pneumocócica
    const coresPneumococica = createArrayDoses(4, [
      '1º DOSE',
      '2ª DOSE',
      'REFORÇO',
      'ÚNICA',
    ])
    const primeiraDosePneumococica = encontrarDose(
      vacinasPendentes,
      vacinasAplicadas,
      '26',
      '1'
    )
    const segundaDosePneumococica = encontrarDose(
      vacinasPendentes,
      vacinasAplicadas,
      '26',
      '2'
    )
    const reforcoPneumococica = encontrarDose(
      vacinasPendentes,
      vacinasAplicadas,
      '26',
      '38'
    )
    const unicaPneumococica = encontrarDose(
      vacinasPendentes,
      vacinasAplicadas,
      '26',
      '9'
    )

    if (primeiraDosePneumococica.tipo == 'aplicada') {
      coresPneumococica[0].cor = 'green'
      coresPneumococica[0].dt_aplicacao_br =
        primeiraDosePneumococica.dt_aplicacao_br
      coresPneumococica[0].dose_anterior =
        primeiraDosePneumococica.dose_anterior
    } else {
      coresPneumococica[0].cor = primeiraDosePneumococica.cor
      coresPneumococica[0].dt_aplicacao_br = '2 meses'
      coresPneumococica[0].sg_d = primeiraDosePneumococica.sg_d
      coresPneumococica[0].sg_im = primeiraDosePneumococica.sg_im
    }

    if (segundaDosePneumococica.tipo == 'aplicada') {
      coresPneumococica[1].cor = 'green'
      coresPneumococica[1].dt_aplicacao_br =
        segundaDosePneumococica.dt_aplicacao_br
      coresPneumococica[1].dose_anterior = segundaDosePneumococica.dose_anterior
    } else {
      coresPneumococica[1].cor = segundaDosePneumococica.cor
      coresPneumococica[1].dt_aplicacao_br = '4 meses'
      coresPneumococica[1].sg_d = segundaDosePneumococica.sg_d
      coresPneumococica[1].sg_im = segundaDosePneumococica.sg_im
    }

    if (reforcoPneumococica.tipo == 'aplicada') {
      coresPneumococica[2].cor = 'green'
      coresPneumococica[2].dt_aplicacao_br = reforcoPneumococica.dt_aplicacao_br
      coresPneumococica[2].dose_anterior = reforcoPneumococica.dose_anterior
    } else {
      coresPneumococica[2].cor = reforcoPneumococica.cor
      coresPneumococica[2].dt_aplicacao_br = '12 meses'
      coresPneumococica[2].sg_d = reforcoPneumococica.sg_d
      coresPneumococica[2].sg_im = reforcoPneumococica.sg_im
    }

    if (unicaPneumococica.tipo == 'aplicada') {
      coresPneumococica[3].cor = 'green'
      coresPneumococica[3].dt_aplicacao_br = unicaPneumococica.dt_aplicacao_br
      coresPneumococica[3].dose_anterior = unicaPneumococica.dose_anterior
    } else {
      coresPneumococica[3].cor = 'white'
      coresPneumococica[3].dt_aplicacao_br = '12 meses a 4 anos'
      coresPneumococica[3].sg_d = unicaPneumococica.sg_d
      coresPneumococica[3].sg_im = unicaPneumococica.sg_im
    }

    // Rota virus
    const coresRotaVirus = createArrayDoses(2, ['1ª DOSE', '2ª DOSE'])
    const primeiraDoseRotaVirus = encontrarDose(
      vacinasPendentes,
      vacinasAplicadas,
      '45',
      '1'
    )
    const segundaDoseRotaVirus = encontrarDose(
      vacinasPendentes,
      vacinasAplicadas,
      '45',
      '2'
    )

    if (primeiraDoseRotaVirus.tipo == 'aplicada') {
      coresRotaVirus[0].cor = 'green'
      coresRotaVirus[0].dt_aplicacao_br = primeiraDoseRotaVirus.dt_aplicacao_br
      coresRotaVirus[0].dose_anterior = primeiraDoseRotaVirus.dose_anterior
    } else {
      coresRotaVirus[0].cor = primeiraDoseRotaVirus.cor
      coresRotaVirus[0].dt_aplicacao_br = '2 meses'
      coresRotaVirus[0].sg_d = primeiraDoseRotaVirus.sg_d
      coresRotaVirus[0].sg_im = primeiraDoseRotaVirus.sg_im
    }

    if (segundaDoseRotaVirus.tipo == 'aplicada') {
      coresRotaVirus[1].cor = 'green'
      coresRotaVirus[1].dt_aplicacao_br = segundaDoseRotaVirus.dt_aplicacao_br
      coresRotaVirus[1].dose_anterior = segundaDoseRotaVirus.dose_anterior
    } else {
      coresRotaVirus[1].cor = segundaDoseRotaVirus.cor
      coresRotaVirus[1].dt_aplicacao_br = '4 meses'
      coresRotaVirus[1].sg_d = segundaDoseRotaVirus.sg_d
      coresRotaVirus[1].sg_im = segundaDoseRotaVirus.sg_im
    }

    // Meningocócica C (conjugada)
    const coresMeningococicaC = createArrayDoses(3, [
      '1ª DOSE',
      '2ª DOSE',
      'REFORÇO',
    ])
    const primeiraDoseMeningococicaC = encontrarDose(
      vacinasPendentes,
      vacinasAplicadas,
      '41',
      '1'
    )
    const segundaDoseMeningococicaC = encontrarDose(
      vacinasPendentes,
      vacinasAplicadas,
      '41',
      '2'
    )
    const reforcoMeningococicaC = encontrarDose(
      vacinasPendentes,
      vacinasAplicadas,
      '41',
      '38'
    )

    if (primeiraDoseMeningococicaC.tipo == 'aplicada') {
      coresMeningococicaC[0].cor = 'green'
      coresMeningococicaC[0].dt_aplicacao_br =
        primeiraDoseMeningococicaC.dt_aplicacao_br
      coresMeningococicaC[0].dose_anterior =
        primeiraDoseMeningococicaC.dose_anterior
    } else {
      coresMeningococicaC[0].cor = primeiraDoseMeningococicaC.cor
      coresMeningococicaC[0].dt_aplicacao_br = '2 meses'
      coresMeningococicaC[0].sg_d = primeiraDoseMeningococicaC.sg_d
      coresMeningococicaC[0].sg_im = primeiraDoseMeningococicaC.sg_im
    }

    if (segundaDoseMeningococicaC.tipo == 'aplicada') {
      coresMeningococicaC[1].cor = 'green'
      coresMeningococicaC[1].dt_aplicacao_br =
        segundaDoseMeningococicaC.dt_aplicacao_br
      coresMeningococicaC[1].dose_anterior =
        segundaDoseMeningococicaC.dose_anterior
    } else {
      coresMeningococicaC[1].cor = segundaDoseMeningococicaC.cor
      coresMeningococicaC[1].dt_aplicacao_br = '5 meses'
      coresMeningococicaC[1].sg_d = segundaDoseMeningococicaC.sg_d
      coresMeningococicaC[1].sg_im = segundaDoseMeningococicaC.sg_im
    }

    if (reforcoMeningococicaC.tipo == 'aplicada') {
      coresMeningococicaC[2].cor = 'green'
      if (
        reforcoMeningococicaC.id_dose_imuno != null &&
        reforcoMeningococicaC.id_dose_imuno != '1' &&
        reforcoMeningococicaC.id_dose_imuno != '2'
      ) {
        coresMeningococicaC[2].dt_aplicacao_br =
          reforcoMeningococicaC.dt_aplicacao_br
      }
      coresMeningococicaC[2].dose_anterior = reforcoMeningococicaC.dose_anterior
    } else {
      coresMeningococicaC[2].cor = reforcoMeningococicaC.cor
      coresMeningococicaC[2].dt_aplicacao_br = '12 meses'
      coresMeningococicaC[2].sg_d = reforcoMeningococicaC.sg_d
      coresMeningococicaC[2].sg_im = reforcoMeningococicaC.sg_im
    }

    // Febre Amarela
    const coresFebreAmarela = createArrayDoses(3, ['DOSE', 'REFORÇO', 'ÚNICA'])
    const primeiraDoseFebreAmarela = encontrarDose(
      vacinasPendentes,
      vacinasAplicadas,
      '14',
      '1'
    )
    const doseFebreAmarela = encontrarDose(
      vacinasPendentes,
      vacinasAplicadas,
      '14',
      '8'
    )
    const reforcoFebreAmarela = encontrarDose(
      vacinasPendentes,
      vacinasAplicadas,
      '14',
      '38'
    )
    const unicaFebreAmarela = encontrarDose(
      vacinasPendentes,
      vacinasAplicadas,
      '14',
      '9'
    )

    if (primeiraDoseFebreAmarela.tipo == 'aplicada') {
      coresFebreAmarela[0].cor = 'green'
      coresFebreAmarela[0].dt_aplicacao_br =
        primeiraDoseFebreAmarela.dt_aplicacao_br
      coresFebreAmarela[0].dose_anterior =
        primeiraDoseFebreAmarela.dose_anterior
    } else if (doseFebreAmarela.tipo == 'aplicada') {
      coresFebreAmarela[0].cor = 'green'
      coresFebreAmarela[0].dt_aplicacao_br = doseFebreAmarela.dt_aplicacao_br
      coresFebreAmarela[0].dose_anterior = doseFebreAmarela.dose_anterior
    } else {
      coresFebreAmarela[0].cor = 'white'
      coresFebreAmarela[0].dt_aplicacao_br = '9 meses'
      // coresFebreAmarela[0].sg_d = doseFebreAmarela
      //   ? doseFebreAmarela.sg_d
      //   : 'defaultSgD'
      // coresFebreAmarela[0].sg_im = doseFebreAmarela
      //   ? doseFebreAmarela.sg_im
      //   : 'defaultSgIm'
    }

    if (reforcoFebreAmarela.tipo == 'aplicada') {
      coresFebreAmarela[1].cor = 'green'
      coresFebreAmarela[1].dt_aplicacao_br = reforcoFebreAmarela.dt_aplicacao_br
      coresFebreAmarela[1].dose_anterior = reforcoFebreAmarela.dose_anterior
    } else {
      coresFebreAmarela[1].cor = reforcoFebreAmarela.cor
      coresFebreAmarela[1].dt_aplicacao_br = '4 anos'
      coresFebreAmarela[1].sg_d = reforcoFebreAmarela.sg_d
      coresFebreAmarela[1].sg_im = reforcoFebreAmarela.sg_im
    }

    if (unicaFebreAmarela.tipo == 'aplicada') {
      coresFebreAmarela[2].cor = 'green'
      coresFebreAmarela[2].dt_aplicacao_br = unicaFebreAmarela.dt_aplicacao_br
      coresFebreAmarela[2].dose_anterior = unicaFebreAmarela.dose_anterior
    } else {
      coresFebreAmarela[2].cor = 'white'
      coresFebreAmarela[2].dt_aplicacao_br = '5 a 59 anos'
      coresFebreAmarela[2].sg_d = unicaFebreAmarela.sg_d
      coresFebreAmarela[2].sg_im = unicaFebreAmarela.sg_im
    }

    // Hepatite A
    const coresHepatiteA = createArrayDoses(1, ['ÚNICA'])
    const primeiraDoseHepatiteA = encontrarDose(
      vacinasPendentes,
      vacinasAplicadas,
      '55',
      '1'
    )
    const unicaHepatiteA = encontrarDose(
      vacinasPendentes,
      vacinasAplicadas,
      '55',
      '9'
    )

    if (unicaHepatiteA.tipo == 'aplicada') {
      coresHepatiteA[0].cor = 'green'
      coresHepatiteA[0].dt_aplicacao_br = unicaHepatiteA.dt_aplicacao_br
      coresHepatiteA[0].dose_anterior = unicaHepatiteA.dose_anterior
    } else if (primeiraDoseHepatiteA.tipo == 'aplicada') {
      coresHepatiteA[0].cor = 'green'
      coresHepatiteA[0].dt_aplicacao_br = primeiraDoseHepatiteA.dt_aplicacao_br
      coresHepatiteA[0].dose_anterior = primeiraDoseHepatiteA.dose_anterior
    } else {
      coresHepatiteA[0].cor = unicaHepatiteA.cor
      coresHepatiteA[0].dt_aplicacao_br = '15 meses'
      coresHepatiteA[0].sg_d = unicaHepatiteA.sg_d
      coresHepatiteA[0].sg_im = unicaHepatiteA.sg_im
    }

    // Tríplice Viral
    const coresTripliceViral = createArrayDoses(3, [
      '1ª DOSE',
      '2ª DOSE',
      'DOSE',
    ])
    const primeiraDoseTripliceViral = encontrarDose(
      vacinasPendentes,
      vacinasAplicadas,
      '24',
      '1'
    )
    const segundaDoseTripliceViral = encontrarDose(
      vacinasPendentes,
      vacinasAplicadas,
      '24',
      '2'
    )
    const doseTripliceViral = encontrarDose(
      vacinasPendentes,
      vacinasAplicadas,
      '24',
      '8'
    )

    if (primeiraDoseTripliceViral.tipo == 'aplicada') {
      coresTripliceViral[0].cor = 'green'
      coresTripliceViral[0].dt_aplicacao_br =
        primeiraDoseTripliceViral.dt_aplicacao_br
      coresTripliceViral[0].dose_anterior =
        primeiraDoseTripliceViral.dose_anterior
    } else {
      coresTripliceViral[0].cor = primeiraDoseTripliceViral.cor
      coresTripliceViral[0].dt_aplicacao_br = '12 meses'
      coresTripliceViral[0].sg_d = primeiraDoseTripliceViral.sg_d
      coresTripliceViral[0].sg_im = primeiraDoseTripliceViral.sg_im
    }

    if (segundaDoseTripliceViral.tipo == 'aplicada') {
      coresTripliceViral[1].cor = 'green'
      coresTripliceViral[1].dt_aplicacao_br =
        segundaDoseTripliceViral.dt_aplicacao_br
      coresTripliceViral[1].dose_anterior =
        segundaDoseTripliceViral.dose_anterior
    } else {
      coresTripliceViral[1].cor = segundaDoseTripliceViral.cor
      coresTripliceViral[1].sg_d = segundaDoseTripliceViral.sg_d
      coresTripliceViral[1].sg_im = segundaDoseTripliceViral.sg_im
    }

    if (doseTripliceViral.tipo == 'aplicada') {
      coresTripliceViral[2].cor = 'green'
      coresTripliceViral[2].dt_aplicacao_br = doseTripliceViral.dt_aplicacao_br
      coresTripliceViral[2].dose_anterior = doseTripliceViral.dose_anterior
    } else {
      coresTripliceViral[2].cor = doseTripliceViral.cor
      coresTripliceViral[2].sg_d = doseTripliceViral.sg_d
      coresTripliceViral[2].sg_im = doseTripliceViral.sg_im
    }

    // Varicela
    const coresVaricela = createArrayDoses(3, ['1ª DOSE', '2ª DOSE', 'ÚNICA'])
    const primeiraDoseVaricela = encontrarDose(
      vacinasPendentes,
      vacinasAplicadas,
      '34',
      '1'
    )
    const segundaDoseVaricela = encontrarDose(
      vacinasPendentes,
      vacinasAplicadas,
      '34',
      '2'
    )
    const unicaVaricela = encontrarDose(
      vacinasPendentes,
      vacinasAplicadas,
      '34',
      '9'
    )

    if (primeiraDoseVaricela.tipo == 'aplicada') {
      coresVaricela[0].cor = 'green'
      coresVaricela[0].dt_aplicacao_br = primeiraDoseVaricela.dt_aplicacao_br
      coresVaricela[0].dose_anterior = primeiraDoseVaricela.dose_anterior
    } else {
      coresVaricela[0].cor = primeiraDoseVaricela.cor
      coresVaricela[0].dt_aplicacao_br = '15 meses'
      coresVaricela[0].sg_d = primeiraDoseVaricela.sg_d
      coresVaricela[0].sg_im = primeiraDoseVaricela.sg_im
    }

    if (segundaDoseVaricela.tipo == 'aplicada') {
      coresVaricela[1].cor = 'green'
      coresVaricela[1].dt_aplicacao_br = segundaDoseVaricela.dt_aplicacao_br
      coresVaricela[1].dose_anterior = segundaDoseVaricela.dose_anterior
    } else {
      coresVaricela[1].cor = segundaDoseVaricela.cor
      coresVaricela[1].dt_aplicacao_br = '4 a 6 anos'
      coresVaricela[1].sg_d = segundaDoseVaricela.sg_d
      coresVaricela[1].sg_im = segundaDoseVaricela.sg_im
    }

    if (unicaVaricela.tipo == 'aplicada') {
      coresVaricela[2].cor = 'green'
      coresVaricela[2].dt_aplicacao_br = unicaVaricela.dt_aplicacao_br
      coresVaricela[2].dose_anterior = unicaVaricela.dose_anterior
    } else {
      coresVaricela[2].cor = unicaVaricela.cor
      coresVaricela[2].dt_aplicacao_br = ''
      coresVaricela[2].sg_d = unicaVaricela.sg_d
      coresVaricela[2].sg_im = unicaVaricela.sg_im
    }

    // HPV
    const coresHpv = createArrayDoses(3, ['1ª DOSE', '2ª DOSE', 'ÚNICA'])
    const primeiraDoseHpv = encontrarDose(
      vacinasPendentes,
      vacinasAplicadas,
      '67',
      '1'
    )
    const segundaDoseHpv = encontrarDose(
      vacinasPendentes,
      vacinasAplicadas,
      '67',
      '2'
    )
    const doseUnicaHpv = encontrarDose(
      vacinasPendentes,
      vacinasAplicadas,
      '67',
      '9'
    )

    if (primeiraDoseHpv.tipo == 'aplicada') {
      coresHpv[0].cor = 'green'
      coresHpv[0].dt_aplicacao_br = primeiraDoseHpv.dt_aplicacao_br
      coresHpv[0].dose_anterior = primeiraDoseHpv.dose_anterior
    } else {
      coresHpv[0].cor = 'white'
      coresHpv[0].dt_aplicacao_br = ''
      coresHpv[0].sg_d = primeiraDoseHpv.sg_d
      coresHpv[0].sg_im = primeiraDoseHpv.sg_im
    }

    if (segundaDoseHpv.tipo == 'aplicada') {
      coresHpv[1].cor = 'green'
      coresHpv[1].dt_aplicacao_br = segundaDoseHpv.dt_aplicacao_br
      coresHpv[1].dose_anterior = segundaDoseHpv.dose_anterior
    } else {
      coresHpv[1].cor = 'white'
      coresHpv[1].dt_aplicacao_br = ''
      coresHpv[1].sg_d = segundaDoseHpv.sg_d
      coresHpv[1].sg_im = segundaDoseHpv.sg_im
    }

    if (doseUnicaHpv.tipo == 'aplicada') {
      coresHpv[2].cor = 'green'
      coresHpv[2].dt_aplicacao_br = doseUnicaHpv.dt_aplicacao_br
      coresHpv[2].dose_anterior = doseUnicaHpv.dose_anterior
    } else {
      coresHpv[2].cor = doseUnicaHpv.cor
      coresHpv[2].dt_aplicacao_br = '9 a 14 anos'
      coresHpv[2].sg_d = doseUnicaHpv.sg_d
      coresHpv[2].sg_im = doseUnicaHpv.sg_im
    }

    // ACWY
    const coresAcwy = createArrayDoses(2, ['DOSE', 'REFORÇO'])
    const doseAcwy = encontrarDose(
      vacinasPendentes,
      vacinasAplicadas,
      '74',
      '8'
    )
    const reforcoAcwy = encontrarDose(
      vacinasPendentes,
      vacinasAplicadas,
      '74',
      '38'
    )

    if (doseAcwy.tipo == 'aplicada') {
      coresAcwy[0].cor = 'green'
      coresAcwy[0].dt_aplicacao_br = doseAcwy.dt_aplicacao_br
      coresAcwy[0].dose_anterior = doseAcwy.dose_anterior
    } else {
      coresAcwy[0].cor = doseAcwy.cor
      coresAcwy[0].dt_aplicacao_br = '11 a 14 anos'
      coresAcwy[0].sg_d = doseAcwy.sg_d
      coresAcwy[0].sg_im = doseAcwy.sg_im
    }

    if (reforcoAcwy.tipo == 'aplicada') {
      coresAcwy[1].cor = 'green'
      coresAcwy[1].dt_aplicacao_br = reforcoAcwy.dt_aplicacao_br
      coresAcwy[1].dose_anterior = reforcoAcwy.dose_anterior
    } else {
      coresAcwy[1].cor = reforcoAcwy.cor
      coresAcwy[1].dt_aplicacao_br = '11 a 14 anos'
      coresAcwy[1].sg_d = reforcoAcwy.sg_d
      coresAcwy[1].sg_im = reforcoAcwy.sg_im
    }

    // PFIZER COMIRNATY PEDIÁTRICA
    const coresPfizerCominartyPediatrica = createArrayDoses(3, [
      '1ª DOSE',
      '2ª DOSE',
      '3ª DOSE',
    ])
    const primeiraDosePfizerCominartyPediatrica = encontrarDose(
      vacinasPendentes,
      vacinasAplicadas,
      '102',
      '1'
    )
    const segundaDosePfizerCominartyPediatrica = encontrarDose(
      vacinasPendentes,
      vacinasAplicadas,
      '102',
      '2'
    )
    const terceiraDosePfizerCominartyPediatrica = encontrarDose(
      vacinasPendentes,
      vacinasAplicadas,
      '102',
      '3'
    )

    if (primeiraDosePfizerCominartyPediatrica.tipo == 'aplicada') {
      coresPfizerCominartyPediatrica[0].cor = 'green'
      coresPfizerCominartyPediatrica[0].dt_aplicacao_br =
        primeiraDosePfizerCominartyPediatrica.dt_aplicacao_br
      coresPfizerCominartyPediatrica[0].dose_anterior =
        primeiraDosePfizerCominartyPediatrica.dose_anterior
    } else {
      coresPfizerCominartyPediatrica[0].cor =
        primeiraDosePfizerCominartyPediatrica.cor
      coresPfizerCominartyPediatrica[0].dt_aplicacao_br = ''
      coresPfizerCominartyPediatrica[0].sg_d =
        primeiraDosePfizerCominartyPediatrica.sg_d
      coresPfizerCominartyPediatrica[0].sg_im =
        primeiraDosePfizerCominartyPediatrica.sg_im
    }

    if (segundaDosePfizerCominartyPediatrica.tipo == 'aplicada') {
      coresPfizerCominartyPediatrica[1].cor = 'green'
      coresPfizerCominartyPediatrica[1].dt_aplicacao_br =
        segundaDosePfizerCominartyPediatrica.dt_aplicacao_br
      coresPfizerCominartyPediatrica[1].dose_anterior =
        segundaDosePfizerCominartyPediatrica.dose_anterior
    } else {
      coresPfizerCominartyPediatrica[1].cor =
        segundaDosePfizerCominartyPediatrica.cor
      coresPfizerCominartyPediatrica[1].dt_aplicacao_br = ''
      coresPfizerCominartyPediatrica[1].sg_d =
        segundaDosePfizerCominartyPediatrica.sg_d
      coresPfizerCominartyPediatrica[1].sg_im =
        segundaDosePfizerCominartyPediatrica.sg_im
    }

    if (terceiraDosePfizerCominartyPediatrica.tipo == 'aplicada') {
      coresPfizerCominartyPediatrica[2].cor = 'green'
      coresPfizerCominartyPediatrica[2].dt_aplicacao_br =
        terceiraDosePfizerCominartyPediatrica.dt_aplicacao_br
      coresPfizerCominartyPediatrica[2].dose_anterior =
        terceiraDosePfizerCominartyPediatrica.dose_anterior
    } else {
      coresPfizerCominartyPediatrica[2].cor = 'white'
      coresPfizerCominartyPediatrica[2].dt_aplicacao_br = ''
      coresPfizerCominartyPediatrica[2].sg_d =
        terceiraDosePfizerCominartyPediatrica.sg_d
      coresPfizerCominartyPediatrica[2].sg_im =
        terceiraDosePfizerCominartyPediatrica.sg_im
    }

    // Sinovac / Butantan - Coronavac
    const coresSinovacButantanCoronavac = createArrayDoses(3, [
      '1ª DOSE',
      '2ª DOSE',
      '3ª DOSE',
    ])
    const primeiraDoseSinovacButantanCoronavac = encontrarDose(
      vacinasPendentes,
      vacinasAplicadas,
      '86',
      '1'
    )
    const segundaDoseSinovacButantanCoronavac = encontrarDose(
      vacinasPendentes,
      vacinasAplicadas,
      '86',
      '2'
    )
    const terceiraDoseSinovacButantanCoronavac = encontrarDose(
      vacinasPendentes,
      vacinasAplicadas,
      '86',
      '3'
    )

    if (primeiraDoseSinovacButantanCoronavac.tipo == 'aplicada') {
      coresSinovacButantanCoronavac[0].cor = 'green'
      coresSinovacButantanCoronavac[0].dt_aplicacao_br =
        primeiraDoseSinovacButantanCoronavac.dt_aplicacao_br
      coresSinovacButantanCoronavac[0].dose_anterior =
        primeiraDoseSinovacButantanCoronavac.dose_anterior
    } else {
      coresSinovacButantanCoronavac[0].cor =
        primeiraDoseSinovacButantanCoronavac.cor
      coresSinovacButantanCoronavac[0].dt_aplicacao_br = ''
      coresSinovacButantanCoronavac[0].sg_d =
        primeiraDoseSinovacButantanCoronavac.sg_d
      coresSinovacButantanCoronavac[0].sg_im =
        primeiraDoseSinovacButantanCoronavac.sg_im
    }

    if (segundaDoseSinovacButantanCoronavac.tipo == 'aplicada') {
      coresSinovacButantanCoronavac[1].cor = 'green'
      coresSinovacButantanCoronavac[1].dt_aplicacao_br =
        segundaDoseSinovacButantanCoronavac.dt_aplicacao_br
      coresSinovacButantanCoronavac[1].dose_anterior =
        segundaDoseSinovacButantanCoronavac.dose_anterior
    } else {
      coresSinovacButantanCoronavac[1].cor =
        segundaDoseSinovacButantanCoronavac.cor
      coresSinovacButantanCoronavac[1].dt_aplicacao_br = ''
      coresSinovacButantanCoronavac[1].sg_d =
        segundaDoseSinovacButantanCoronavac.sg_d
      coresSinovacButantanCoronavac[1].sg_im =
        segundaDoseSinovacButantanCoronavac.sg_im
    }

    if (terceiraDoseSinovacButantanCoronavac.tipo == 'aplicada') {
      coresSinovacButantanCoronavac[2].cor = 'green'
      coresSinovacButantanCoronavac[2].dt_aplicacao_br =
        terceiraDoseSinovacButantanCoronavac.dt_aplicacao_br
      coresSinovacButantanCoronavac[2].dose_anterior =
        terceiraDoseSinovacButantanCoronavac.dose_anterior
    } else {
      coresSinovacButantanCoronavac[2].cor = 'white'
      coresSinovacButantanCoronavac[2].dt_aplicacao_br = ''
      coresSinovacButantanCoronavac[2].sg_d =
        terceiraDoseSinovacButantanCoronavac.sg_d
      coresSinovacButantanCoronavac[2].sg_im =
        terceiraDoseSinovacButantanCoronavac.sg_im
    }

    // Dupla adulto
    const coresDuplaAdulto = createArrayDoses(4, [
      '1ª DOSE',
      '2ª DOSE',
      '3ª DOSE',
      'REFORÇO',
    ])
    const primeiraDoseDuplaAdulto = encontrarDose(
      vacinasPendentes,
      vacinasAplicadas,
      '25',
      '1'
    )
    const segundaDoseDuplaAdulto = encontrarDose(
      vacinasPendentes,
      vacinasAplicadas,
      '25',
      '2'
    )
    const terceiraDoseDuplaAdulto = encontrarDose(
      vacinasPendentes,
      vacinasAplicadas,
      '25',
      '3'
    )
    const reforcoDuplaAdulto = encontrarDose(
      vacinasPendentes,
      vacinasAplicadas,
      '25',
      '38'
    )

    if (primeiraDoseDuplaAdulto.tipo == 'aplicada') {
      coresDuplaAdulto[0].cor = 'green'
      coresDuplaAdulto[0].dt_aplicacao_br =
        primeiraDoseDuplaAdulto.dt_aplicacao_br
      coresDuplaAdulto[0].dose_anterior = primeiraDoseDuplaAdulto.dose_anterior
    } else {
      coresDuplaAdulto[0].cor = primeiraDoseDuplaAdulto.cor
      coresDuplaAdulto[0].dt_aplicacao_br = ''
      coresDuplaAdulto[0].sg_d = primeiraDoseDuplaAdulto.sg_d
      coresDuplaAdulto[0].sg_im = primeiraDoseDuplaAdulto.sg_im
    }

    if (segundaDoseDuplaAdulto.tipo == 'aplicada') {
      coresDuplaAdulto[1].cor = 'green'
      coresDuplaAdulto[1].dt_aplicacao_br =
        segundaDoseDuplaAdulto.dt_aplicacao_br
      coresDuplaAdulto[1].dose_anterior = segundaDoseDuplaAdulto.dose_anterior
    } else {
      coresDuplaAdulto[1].cor = segundaDoseDuplaAdulto.cor
      coresDuplaAdulto[1].dt_aplicacao_br = ''
      coresDuplaAdulto[1].sg_d = segundaDoseDuplaAdulto.sg_d
      coresDuplaAdulto[1].sg_im = segundaDoseDuplaAdulto.sg_im
    }

    if (terceiraDoseDuplaAdulto.tipo == 'aplicada') {
      coresDuplaAdulto[2].cor = 'green'
      coresDuplaAdulto[2].dt_aplicacao_br =
        terceiraDoseDuplaAdulto.dt_aplicacao_br
      coresDuplaAdulto[2].dose_anterior = terceiraDoseDuplaAdulto.dose_anterior
    } else {
      coresDuplaAdulto[2].cor = 'white'
      coresDuplaAdulto[2].dt_aplicacao_br = ''
      coresDuplaAdulto[2].sg_d = terceiraDoseDuplaAdulto.sg_d
      coresDuplaAdulto[2].sg_im = terceiraDoseDuplaAdulto.sg_im
    }

    if (reforcoDuplaAdulto.tipo == 'aplicada') {
      coresDuplaAdulto[3].cor = 'green'
      coresDuplaAdulto[3].dt_aplicacao_br = reforcoDuplaAdulto.dt_aplicacao_br
      coresDuplaAdulto[3].dose_anterior = reforcoDuplaAdulto.dose_anterior
    } else {
      coresDuplaAdulto[3].cor = 'white'
      coresDuplaAdulto[3].dt_aplicacao_br = ''
      coresDuplaAdulto[3].sg_d = reforcoDuplaAdulto.sg_d
      coresDuplaAdulto[3].sg_im = reforcoDuplaAdulto.sg_im
    }

    return {
      id: index,
      ...item,
      coresPentaValente,
      coresVip,
      coresDtp,
      coresBcg,
      coresHepatiteB,
      coresVop,
      coresPneumococica,
      coresRotaVirus,
      coresMeningococicaC,
      coresFebreAmarela,
      coresHepatiteA,
      coresTripliceViral,
      coresVaricela,
      coresHexa,
      coresHpv,
      coresAcwy,
      coresDuplaAdulto,
      coresCovid19,
      // coresPfizerCominartyPediatrica,
      // coresSinovacButantanCoronavac,
    }
  })

  return data
}

function createArrayDoses(quantElements, labels) {
  let data = []
  for (let index = 0; index < quantElements; index++) {
    data.push({
      dose: `${labels[index]}`,
      cor: 'white',
      dt_aplicacao_br: '',
      dose_anterior: '',
      sg_d: '',
      sg_im: '',
    })
  }
  return data
}

function encontrarDose(vacinasPendentes, vacinasAplicadas, id_im, id_d) {
  if (vacinasPendentes != null) {
    const dosePendente = vacinasPendentes.find(
      (el) => el.id_im == Number(id_im) && el.id_d == Number(id_d)
    )
    if (dosePendente !== undefined) {
      return {
        tipo: 'pendente',
        cor: 'red',
        dt_aplicacao_br: '',
        sg_d: dosePendente.sg_d,
        sg_im: dosePendente.sg_im,
      }
    }
  }
  if (vacinasAplicadas != null) {
    const doseAplicada = vacinasAplicadas.find(
      (el) => el.id_imuno == id_im && el.id_dose_imuno == id_d
    )
    if (doseAplicada !== undefined) {
      return {
        tipo: 'aplicada',
        dt_aplicacao: doseAplicada.dt_aplicacao,
        dt_aplicacao_br: doseAplicada.dt_aplicacao_br,
        dose_anterior: doseAplicada.dose_anterior,
        id_dose_imuno: doseAplicada.id_dose_imuno,
      }
    }
  }
  return {
    tipo: 'pendente',
    cor: 'white',
    dt_aplicacao_br: '',
    sg_d: '',
    sg_im: '',
  }
}

function encontrarDosesCovid19(vacinasPendentes, vacinasAplicadas) {
  let data = {
    pendentes: [],
    aplicadas: [],
  }
  let imunos = [
    '85',
    '86',
    '87',
    '88',
    '89',
    '97',
    '98',
    '99',
    '102',
    '103',
    '105',
  ]
  let doses = ['1', '2', '3']

  if (vacinasPendentes != null) {
    const dosesPendentes = vacinasPendentes.filter(
      (el) =>
        imunos.includes(String(el.id_im)) && doses.includes(String(el.id_d))
    )
    if (dosesPendentes !== undefined) {
      data.pendentes = dosesPendentes
    }
  }
  if (vacinasAplicadas != null) {
    const dosesAplicadas = vacinasAplicadas.filter(
      (el) =>
        imunos.includes(String(el.id_imuno)) &&
        doses.includes(String(el.id_dose_imuno))
    )
    if (dosesAplicadas !== undefined) {
      data.aplicadas = dosesAplicadas
    }
  }

  let coresCovid19 = createArrayDoses(3, ['1ª DOSE', '2ª DOSE', '3ª DOSE'])
  let primeiraDose = data.aplicadas.find((el) => {
    return el.id_dose_imuno == '1'
  })
  let segundaDose = data.aplicadas.find((el) => {
    return el.id_dose_imuno == '2'
  })
  let terceiraDose = data.aplicadas.find((el) => {
    return el.id_dose_imuno == '3'
  })

  if (primeiraDose != undefined) {
    coresCovid19[0].cor = 'green'
    coresCovid19[0].dt_aplicacao_br = primeiraDose.dt_aplicacao_br
    coresCovid19[0].dose_anterior = primeiraDose.dose_anterior
  } else {
    let primeiraDosePendente = data.pendentes.find((el) => {
      return el.id_d == '1' && el.id_im == '99'
    })
    if (primeiraDosePendente) {
      coresCovid19[0].cor = 'red'
    }
    coresCovid19[0].dt_aplicacao_br = '6 meses'
  }

  if (segundaDose != undefined) {
    coresCovid19[1].cor = 'green'
    coresCovid19[1].dt_aplicacao_br = segundaDose.dt_aplicacao_br
    coresCovid19[1].dose_anterior = segundaDose.dose_anterior
  } else {
    let segundaDosePendente = data.pendentes.find((el) => {
      return el.id_d == '2' && el.id_im == '99'
    })
    if (segundaDosePendente) {
      coresCovid19[1].cor = 'red'
    }
    coresCovid19[1].dt_aplicacao_br = '7 meses'
  }

  if (terceiraDose != undefined) {
    coresCovid19[2].cor = 'green'
    coresCovid19[2].dt_aplicacao_br = terceiraDose.dt_aplicacao_br
    coresCovid19[2].dose_anterior = terceiraDose.dose_anterior
  } else {
    let terceiraDosePendente = data.pendentes.find((el) => {
      return el.id_d == '3' && el.id_im == '99'
    })
    if (terceiraDosePendente) {
      coresCovid19[2].cor = 'red'
    }
    coresCovid19[2].dt_aplicacao_br = '9 meses'
  }
  return coresCovid19
}

export function exibirVermelhos(cadastros) {
  const cadastrosFormatados = formatarCadastrosComDoses(cadastros)
  const filtro = cadastrosFormatados.filter((item) => {
    if (
      item.coresCovid19.find((element) => element.cor === 'red') ||
      item.coresHexa.find((element) => element.cor === 'red') ||
      item.coresPentaValente.find((element) => element.cor === 'red') ||
      item.coresVip.find((element) => element.cor === 'red') ||
      item.coresDtp.find((element) => element.cor === 'red') ||
      item.coresBcg.find((element) => element.cor === 'red') ||
      item.coresHepatiteB.find((element) => element.cor === 'red') ||
      item.coresVop.find((element) => element.cor === 'red') ||
      item.coresPneumococica.find((element) => element.cor === 'red') ||
      item.coresRotaVirus.find((element) => element.cor === 'red') ||
      item.coresMeningococicaC.find((element) => element.cor === 'red') ||
      item.coresFebreAmarela.find((element) => element.cor === 'red') ||
      item.coresHepatiteA.find((element) => element.cor === 'red') ||
      item.coresTripliceViral.find((element) => element.cor === 'red') ||
      item.coresVaricela.find((element) => element.cor === 'red') ||
      item.coresHpv.find((element) => element.cor === 'red') ||
      item.coresAcwy.find((element) => element.cor === 'red') ||
      item.coresDuplaAdulto.find((element) => element.cor === 'red')
    ) {
      return true
    }
  })
  return filtro
}

export function exibirVerdes(cadastros) {
  const cadastrosFormatados = formatarCadastrosComDoses(cadastros)
  const filtro = cadastrosFormatados.filter((item) => {
    if (
      item.coresCovid19.every(
        (element) => element.cor === 'green' || element.cor === 'white'
      ) &&
      item.coresHexa.every(
        (element) => element.cor === 'green' || element.cor === 'white'
      ) &&
      item.coresPentaValente.every(
        (element) => element.cor === 'green' || element.cor === 'white'
      ) &&
      item.coresVip.every(
        (element) => element.cor === 'green' || element.cor === 'white'
      ) &&
      item.coresDtp.every(
        (element) => element.cor === 'green' || element.cor === 'white'
      ) &&
      item.coresBcg.every(
        (element) => element.cor === 'green' || element.cor === 'white'
      ) &&
      item.coresHepatiteB.every(
        (element) => element.cor === 'green' || element.cor === 'white'
      ) &&
      item.coresVop.every(
        (element) => element.cor === 'green' || element.cor === 'white'
      ) &&
      item.coresPneumococica.every(
        (element) => element.cor === 'green' || element.cor === 'white'
      ) &&
      item.coresRotaVirus.every(
        (element) => element.cor === 'green' || element.cor === 'white'
      ) &&
      item.coresMeningococicaC.every(
        (element) => element.cor === 'green' || element.cor === 'white'
      ) &&
      item.coresFebreAmarela.every(
        (element) => element.cor === 'green' || element.cor === 'white'
      ) &&
      item.coresHepatiteA.every(
        (element) => element.cor === 'green' || element.cor === 'white'
      ) &&
      item.coresTripliceViral.every(
        (element) => element.cor === 'green' || element.cor === 'white'
      ) &&
      item.coresVaricela.every(
        (element) => element.cor === 'green' || element.cor === 'white'
      ) &&
      item.coresHpv.every(
        (element) => element.cor === 'green' || element.cor === 'white'
      ) &&
      item.coresAcwy.every(
        (element) => element.cor === 'green' || element.cor === 'white'
      ) &&
      item.coresDuplaAdulto.every(
        (element) => element.cor === 'green' || element.cor === 'white'
      )
    ) {
      return true
    }
  })
  return filtro
}

export function handleFilter(data, filter) {
  let filtrado = data.filter((item) => {
    if (filter === null) {
      return item
    }
    if (filter === '0 - 24 meses') {
      return Number(item.idade_meses) >= 0 && Number(item.idade_meses) <= 24
    } else if (filter === '2 - 4 anos') {
      return Number(item.idade_anos) >= 2 && Number(item.idade_anos) <= 4
    } else if (filter === '5 - 10 anos') {
      return Number(item.idade_anos) >= 5 && Number(item.idade_anos) <= 10
    } else if (filter === '11 - 14 anos') {
      return Number(item.idade_anos) >= 11 && Number(item.idade_anos) <= 14
    } else {
      return item
    }
  })
  return filtrado
}

function formatarVacinasAplicadasParaPdf(doses, label) {
  const dosesAplicadas = doses.filter((obj) => obj.cor === 'green')
  return dosesAplicadas.length > 0
    ? label + ' (' + dosesAplicadas.map((obj) => obj.dose).join(', ') + '); '
    : ''
}

function formatarVacinasPendentesParaPdf(doses, label) {
  const dosesPendentes = doses.filter((obj) => obj.cor === 'red')
  return dosesPendentes.length > 0
    ? dosesPendentes[0].sg_im +
        ' (' +
        dosesPendentes.map((obj) => obj.sg_d).join(', ') +
        '); '
    : ''
}

export function generatePdf(cadastros, selectEquipe, nomeProfissional, filtro) {
  let cadastrosPdf = formatarCadastrosComDoses(cadastros)
  let title_pdf = '0 - 15 anos'
  let titlePdfSave = utils.methods.titlePdf(
    '0 - 15 anos',
    selectEquipe.no_equipe
  )

  let description_pdf = 'Situação vacinal de crianças com menos de 0 a 15 anos'
  let headers_pdf = [
    'DADOS PESSOAIS',
    'VACINAS PENDENTES',
    'VACINAS APLICADAS',
    'DOCUMENTO',
  ]
  var data_pdf = []
  for (let i = 0; i < cadastrosPdf.length; i++) {
    let obj = {}
    obj.dados_pessoais = `Nome: ${
      cadastrosPdf[i].no_cidadao
    }\nNascimento: ${utils.methods.formatDate(cadastrosPdf[i].dt_nascimento)} ${
      cadastrosPdf[i].idade_meses > 24
        ? `(${cadastrosPdf[i].idade_anos} anos)`
        : `(${cadastrosPdf[i].idade_meses} ${
            cadastrosPdf[i].idade_meses == 0 || cadastrosPdf[i].idade_meses == 1
              ? 'mês'
              : 'meses'
          })`
    }\nMãe: ${cadastrosPdf[i].no_mae}\nMA: ${
      cadastrosPdf[i].micro_area ?? ''
    }\n`

    obj.vacinas_pendentes = `${formatarVacinasPendentesParaPdf(
      cadastrosPdf[i].coresBcg,
      'bcg'
    )}${formatarVacinasPendentesParaPdf(
      cadastrosPdf[i].coresHepatiteB,
      'hb'
    )}${formatarVacinasPendentesParaPdf(
      cadastrosPdf[i].coresPentaValente,
      'DTP/HB/Hib'
    )}${formatarVacinasPendentesParaPdf(
      cadastrosPdf[i].coresDtp,
      'dtp'
    )}${formatarVacinasPendentesParaPdf(
      cadastrosPdf[i].coresVip,
      'vip'
    )}${formatarVacinasPendentesParaPdf(
      cadastrosPdf[i].coresVop,
      'vop'
    )}${formatarVacinasPendentesParaPdf(
      cadastrosPdf[i].coresPneumococica,
      'pncc10v'
    )}${formatarVacinasPendentesParaPdf(
      cadastrosPdf[i].coresRotaVirus,
      'vrh'
    )}${formatarVacinasPendentesParaPdf(
      cadastrosPdf[i].coresMeningococicaC,
      'menconjc'
    )}${formatarVacinasPendentesParaPdf(
      cadastrosPdf[i].coresFebreAmarela,
      'fa'
    )}${formatarVacinasPendentesParaPdf(
      cadastrosPdf[i].coresHepatiteA,
      'ha'
    )}${formatarVacinasPendentesParaPdf(
      cadastrosPdf[i].coresTripliceViral,
      'scr'
    )}${formatarVacinasPendentesParaPdf(
      cadastrosPdf[i].coresVaricela,
      'varc'
    )}${formatarVacinasPendentesParaPdf(
      cadastrosPdf[i].coresHpv,
      'hpv'
    )}${formatarVacinasPendentesParaPdf(cadastrosPdf[i].coresAcwy, 'acwy')}
    ${formatarVacinasPendentesParaPdf(cadastrosPdf[i].coresDuplaAdulto, 'dt')}
    ${formatarVacinasPendentesParaPdf(cadastrosPdf[i].coresCovid19, 'covid19')}
    `
    obj.vacinas_aplicadas = `${formatarVacinasAplicadasParaPdf(
      cadastrosPdf[i].coresBcg,
      'BCG'
    )}${formatarVacinasAplicadasParaPdf(
      cadastrosPdf[i].coresHepatiteB,
      'HEPATITE B'
    )}${formatarVacinasAplicadasParaPdf(
      cadastrosPdf[i].coresPentaValente,
      'PENTAVALENTE'
    )}${formatarVacinasAplicadasParaPdf(
      cadastrosPdf[i].coresDtp,
      'DTP'
    )}${formatarVacinasAplicadasParaPdf(
      cadastrosPdf[i].coresVip,
      'VIP'
    )}${formatarVacinasAplicadasParaPdf(
      cadastrosPdf[i].coresVop,
      'VOP'
    )}${formatarVacinasAplicadasParaPdf(
      cadastrosPdf[i].coresPneumococica,
      'PNEUMOCÓCICA 10V (CONJUGADA)'
    )}${formatarVacinasAplicadasParaPdf(
      cadastrosPdf[i].coresRotaVirus,
      'ROTAVÍRUS HUMANO'
    )}${formatarVacinasAplicadasParaPdf(
      cadastrosPdf[i].coresMeningococicaC,
      'MENINGOCÓCICA C (CONJUGADA)'
    )}${formatarVacinasAplicadasParaPdf(
      cadastrosPdf[i].coresFebreAmarela,
      'FEBRE AMARELA'
    )}${formatarVacinasAplicadasParaPdf(
      cadastrosPdf[i].coresHepatiteA,
      'HEPATITE A'
    )}${formatarVacinasAplicadasParaPdf(
      cadastrosPdf[i].coresTripliceViral,
      'TRÍPLICE VIRAL'
    )}${formatarVacinasAplicadasParaPdf(
      cadastrosPdf[i].coresVaricela,
      'VARICELA'
    )}${formatarVacinasAplicadasParaPdf(
      cadastrosPdf[i].coresHpv,
      'HPV'
    )}${formatarVacinasAplicadasParaPdf(cadastrosPdf[i].coresAcwy, 'ACWY')}
    ${formatarVacinasAplicadasParaPdf(
      cadastrosPdf[i].coresDuplaAdulto,
      'DUPLA ADULTO'
    )}
    ${formatarVacinasAplicadasParaPdf(cadastrosPdf[i].coresCovid19, 'COVID 19')}
    `
    let documentoText = ''
    let lineBreak = ''
    if (cadastros[i].nu_cpf !== null && cadastros[i].nu_cpf !== undefined) {
      lineBreak = '\n'
      documentoText += `CPF ${cadastros[i].nu_cpf}`
    }
    if (cadastros[i].nu_cns !== null && cadastros[i].nu_cns !== undefined) {
      documentoText += `${lineBreak}CNS ${cadastros[i].nu_cns}`
    }
    obj.documento = documentoText
    data_pdf.push(obj)
  }
  let doc = new jsPDF('l', 'pt')
  // cria a tabela
  let table = utils.methods.createTablePdf(data_pdf)

  utils.methods
    .fileToBase64(store.state.infoMunicipio.brasao)
    .then((base64data) => {
      // Header
      let verticalPosition = headerPdf(
        doc,
        base64data,
        title_pdf,
        description_pdf
      )
      // Equipe
      if (selectEquipe !== '') {
        doc.setFontSize(12)
        doc.text(
          'Equipe: ' + selectEquipe.no_equipe,
          40,
          verticalPosition,
          null,
          null,
          'left'
        )
        verticalPosition += 16
        doc.text(
          'CNES: ' + selectEquipe.nu_cnes,
          40,
          verticalPosition,
          null,
          null,
          'left'
        )
        verticalPosition += 16
        doc.text(
          'INE: ' + selectEquipe.nu_ine,
          40,
          verticalPosition,
          null,
          null,
          'left'
        )
      }
      // ACS
      if (nomeProfissional != '') {
        verticalPosition += 16
        doc.setFontSize(12)
        doc.text(
          'Profissional: ' + nomeProfissional,
          40,
          verticalPosition,
          null,
          null,
          'left'
        )
      }
      // Filtro
      if (filtro != undefined && filtro !== '') {
        verticalPosition += 16
        doc.text('Filtro: ' + filtro, 40, verticalPosition, null, null, 'left')
      }

      // Data atual
      verticalPosition += 16
      let data = new Date()
      let dia = String(data.getDate()).padStart(2, '0')
      let mes = String(data.getMonth() + 1).padStart(2, '0')
      let ano = data.getFullYear()
      let dataAtual = dia + '/' + mes + '/' + ano
      doc.setFontSize(12)
      doc.text(`Data: ${dataAtual}`, 40, verticalPosition, null, null)

      verticalPosition += 16

      doc.autoTable({
        head: [headers_pdf],
        body: table,
        headStyles: {
          fillColor: '#ccc',
          fontSize: 6,
          textColor: '#000',
          halign: 'center',
          cellWidth: 'wrap',
        },
        columnStyles: {
          0: { cellWidth: 220 },
        },
        bodyStyles: {
          halign: 'left',
          fontSize: 6,
        },
        theme: 'striped',
        startY: verticalPosition,
        showHead: 'firstPage',
      })

      footerPdf(doc, doc.autoTable.previous.finalY)

      doc.save(titlePdfSave + '.pdf')

      vue.$toast.success('PDF GERADO COM SUCESSO!', 'Sucesso:', {
        position: 'topRight',
      })
    })
    .catch((error) => {
      console.error(error)
      vue.$toast.error('ERRO AO GERAR PDF!', 'Erro:', {
        position: 'topRight',
      })
    })
}

function headerPdf(doc, base64data, title_pdf, description_pdf) {
  let verticalPosition = 30
  // Brasão
  const pageWidth = doc.internal.pageSize.getWidth()
  const marginXtext = pageWidth / 2
  const marginXimg = pageWidth / 2 - 20

  if (base64data != '') {
    doc.addImage(base64data, marginXimg, verticalPosition, 40, 40)
    verticalPosition += 55
  }

  doc.setFontSize(14)
  doc.text(
    store.state.cidade,
    marginXtext,
    verticalPosition,
    null,
    null,
    'center'
  )
  verticalPosition += 20
  doc.text(
    'SECRETARIA MUNICIPAL DE SAÚDE',
    marginXtext,
    verticalPosition,
    null,
    null,
    'center'
  )
  // Linha
  verticalPosition += 10
  doc.line(
    10,
    verticalPosition,
    doc.internal.pageSize.getWidth() - 10,
    base64data != '' ? 110 : 55
  )
  verticalPosition += 20
  // Título
  doc.setFontSize(14)
  doc.text(title_pdf, marginXtext, verticalPosition, null, null, 'center')
  verticalPosition += 16
  // Descrição
  doc.setFontSize(12)
  doc.text(description_pdf, marginXtext, verticalPosition, null, null, 'center')
  verticalPosition += 24
  return verticalPosition
}

function footerPdf(doc, verticalPosition, x1Line = 250, widthLine = 600) {
  const pageWidth = doc.internal.pageSize.getWidth()
  const marginXtext = pageWidth / 2
  let position = verticalPosition

  // Data atual
  let data = new Date()
  let dia = String(data.getDate()).padStart(2, '0')
  let mes = String(data.getMonth() + 1).padStart(2, '0')
  let ano = data.getFullYear()
  let dataAtual = dia + '/' + mes + '/' + ano

  doc.setFontSize(12)
  doc.text(
    `${store.state.cidade}, ${dataAtual}.`,
    40,
    (position += 40),
    null,
    null
  )
  // Linha
  doc.line(x1Line, (position += 50), widthLine, position)
  // Responsável
  doc.setFontSize(14)
  doc.text('Responsável', marginXtext, (position += 16), null, null, 'center')
}
export const dataFields = {
  Nome: 'no_cidadao',
  Nascimento: {
    field: 'dt_nascimento',
    callback: (value) => {
      return value !== null ? utils.methods.formatDate(value) : ''
    },
  },
  Mãe: 'no_mae',
  MA: 'micro_area',
}
